'use client';

import React from 'react';
import Box from '../../../atoms/Box/Box';
import Row from '../../../atoms/Grid/Row/Row';
import Col from '../../../atoms/Grid/Col/Col';
import Iconography from '../../../atoms/Iconography/Iconography';
import Typography from '../../../atoms/Typography/Typography';
import Separator from '../../../atoms/Separator/Separator';

import styles from './Footer.module.scss';

interface FooterProps {
  isExpanded: boolean;
  isCollapsed: boolean;
  isHovered: boolean;
  theme: 'light' | 'dark';
  userName: string;
  userEmail: string;
  onSignOut?: () => void;
  dashboardSection?: React.ReactNode;
}

const Footer: React.FC<FooterProps> = ({
  isExpanded,
  isCollapsed,
  isHovered,
  theme,
  userName,
  userEmail,
  onSignOut,
  dashboardSection,
}) => {
  return (
    <Box pb={24} className={styles.userSection}>
      <Separator theme={theme} />
      {dashboardSection && <Box pt={16}>{dashboardSection}</Box>}
      <Box pt={16} pl={8} pr={8}>
        <Row
          gutter={[8, 8]}
          align="top"
          justify={isCollapsed && !isHovered ? 'center' : 'start'}
          wrap={false}
        >
          <Col>
            <Box className={styles.avatar}>
              <Iconography category="global" name="user" size={24} color="white" />
            </Box>
          </Col>
          {isExpanded && (
            <Col className={styles.userDetails}>
              <Typography variant="body" size="medium" color="white" theme={theme}>
                {userName}
              </Typography>
              <Typography variant="body" size="small" color="gray-5" theme={theme}>
                {userEmail}
              </Typography>
              {onSignOut && (
                <Box pt={8}>
                  <button onClick={onSignOut} className={styles.signOut} aria-label="Sign out">
                    <Typography variant="body" size="small" color="primary-1" theme={theme}>
                      Sign Out
                    </Typography>
                  </button>
                </Box>
              )}
            </Col>
          )}
        </Row>
      </Box>
    </Box>
  );
};

Footer.displayName = 'Footer';

export default Footer;
